export default {
  data() {
    return {
      selectedDate: "",
      selectedTime: "",
      note: "",
      isNotifyAllUsers: false,
      selectedNumber: "",
      selectedProject: "",
      isAddingRecordToPlanner: false
    };
  },

  props: {
    projectList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selectedDateTime() {
      return `${this.selectedDate} ${this.selectedTime}:00`;
    },
    formatedNumber() {
      return this.selectedNumber.length === 9 ? `48${this.selectedNumber}` : this.selectedNumber;
    },
    isDisabled() {
      return (
        !this.selectedDate || !this.selectedTime || !this.selectedProject || !this.selectedNumber
      );
    }
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    async addRecordToPlanner() {
      this.isAddingRecordToPlanner = true;
      const params = {
        project_uuid: this.selectedProject,
        num_a: this.formatedNumber,
        call_stamp: this.selectedDateTime,
        note: this.note,
        notify_all_users: this.isNotifyAllUsers
      };
      const response = await this.$store.dispatch("callPlanner/addRecordToPlanner", params);
      if (response) {
        this.$message({
          title: "Sukces",
          message: "Dodano rekord do listy zaplanowanych połączeń.",
          type: "success"
        });
        await this.$store.dispatch("callPlanner/getListCount");
        this.$emit("refreshCalendar");
      } else {
        this.$message({
          message: "Wystąpił bład podczas dodawania do listy zaplanowanych połączeń.",
          type: "error"
        });
      }
      this.note = "";
      this.selectedNumber = "";
      this.isAddingRecordToPlanner = false;
    }
  }
};
